import cx from 'classnames';
import * as React from 'react';

// @ts-ignore
import GroupMembership from 'entities/GroupMembership';
// @ts-ignore
import ModalTrigger from 'components/ModalTrigger';
// @ts-ignore
import RelationshipModal from 'user/components/RelationshipModal';
import Text from 'components/Text';
// @ts-ignore
import UserAvatar from 'users/components/UserAvatar';
// @ts-ignore
import UserLink from 'users/components/UserLink';

import './styles/GroupMemberListItem.scss';

type Props = {
  classMember: GroupMembership;
  highlight?: boolean;
  owner?: boolean;
  className?: string;
};

class GroupMemberListItem extends React.Component<Props> {
  render() {
    const name = this.props.classMember.getName();
    const member = this.props.classMember;
    const user = this.props.classMember.getUser();

    return (
      <li
        className={cx(
          {
            GroupMemberListItem: true,
            'GroupMemberListItem-highlight': this.props.highlight,
          },
          this.props.className
        )}>
        <UserLink
          className="GroupMemberListItem-link"
          userId={member.getUserId()}
          placement="left"
          alignment="top">
          <ModalTrigger modal={<RelationshipModal userId={member.getUserId()} />}>
            <span className="GroupMemberListItem-link-trigger">
              <UserAvatar
                className="GroupMemberListItem-droplet"
                size="medium"
                user={user.toJSON()}
              />
              <Text className="GroupMemberListItem-name">{name}</Text>
            </span>
          </ModalTrigger>
        </UserLink>
      </li>
    );
  }
}

export default GroupMemberListItem;
